<template>
  <div>
    <h6 class="font-weight-bold">Coal Tonnage Current Month</h6>
    <b-table
      v-if="!isEdit"
      class="mt-2 p-0"
      thead-class="bg-color text-center"
      empty-text="No data"
      :items="detail"
      :fields="fields"
      responsive
      show-empty
      bordered
    >
      <template #thead-top>
        <b-tr>
          <b-th rowspan="2">Pit</b-th>
          <b-th rowspan="2">Seam</b-th>
          <b-th rowspan="2">Actual Distance</b-th>
          <b-th rowspan="2">Volume Coal Auxiliary</b-th>
          <b-th rowspan="2">Unit Price (IDR/Ton)</b-th>
          <b-th rowspan="2">Total Price (IDR/Ton)</b-th>
          <b-th colspan="5" class="text-center">Budget Number</b-th>
        </b-tr>
      </template>
      <template v-slot:cell(pit)="items">
          <p class="mt-2 font-weight-bold">{{ items.item.pit }}</p>
      </template>
      <template v-slot:cell(seam)="items">
        <div
          v-for="(n, i) in items.item.volume_item.length + 1"
          :key="i"
          class="p-3 m-0"
          :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
          :style="i === items.item.volume_item.length ? 'background-color: #9ed7d2;color: #9ed7d2' : 'background-color: #fff'"
        >
          {{
            n !== items.item.volume_item.length + 1
              ? items.item.volume_item[i].seam ? items.item.volume_item[i].seam : '-'
              : '-'
          }}
        </div>
      </template>
      <template v-slot:cell(actual_distance)="items">
        <div
          v-for="(n, i) in items.item.volume_item.length + 1"
          :key="i"
          class="p-3 m-0"
          :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
          :style="i === items.item.volume_item.length ? 'background-color: #9ed7d2;color: #9ed7d2' : 'background-color: #fff'"
        >
          {{
            n !== items.item.volume_item.length + 1
              ? formatMoney(
                  parseFloat(items.item.volume_item[i].actual_distance),
                  { symbol: '', precision: '2', thousand: ',' }
                ) || 0
              : '.'
          }}
        </div>
      </template>
      <template v-slot:cell(volume)="items">
         <div
          v-for="(n, i) in items.item.volume_item.length + 1"
          :key="i"
          class="p-3"
          :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
          :style="i === items.item.volume_item.length ? 'background-color: #9ed7d2;font-weight: bold' : 'background-color: #fff'"
        >
          {{
            n !== items.item.volume_item.length + 1
              ? formatMoney(
                  parseFloat(items.item.volume_item[i].volume),
                  { symbol: '', precision: '2', thousand: ',' }
                ) || 0
              : formatMoney(
                  parseFloat(subTotal(items.item.volume_item, 'volume')),
                  { symbol: '', precision: '2', thousand: ',' }
                )
          }}
        </div>
      </template>
      <template v-slot:cell(unit_price)="items">
         <div
          v-for="(n, i) in items.item.volume_item.length + 1"
          :key="i"
          class="p-3"
          :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
          :style="i === items.item.volume_item.length ? 'background-color: #9ed7d2;color: #9ed7d2' : 'background-color: #fff'"
        >
          {{
            n !== items.item.volume_item.length + 1
              ? formatMoney(
                  parseFloat(items.item.volume_item[i].unit_price),
                  { symbol: '', precision: '2', thousand: ',' }
                ) || 0
              : '.'
          }}
        </div>
      </template>
      <template v-slot:cell(total_price)="items">
         <div
          v-for="(n, i) in items.item.volume_item.length + 1"
          :key="i"
          class="p-3"
          :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
          :style="i === items.item.volume_item.length ? 'background-color: #9ed7d2;font-weight: bold' : 'background-color: #fff'"
        >
          {{
            n !== items.item.volume_item.length + 1
              ? formatMoney(
                  parseFloat(items.item.volume_item[i].total_price),
                  { symbol: '', precision: '2', thousand: ',' }
                ) || 0
              : formatMoney(
                  parseFloat(subTotal(items.item.volume_item, 'total_price')),
                  { symbol: '', precision: '2', thousand: ',' }
                )
          }}
        </div>
      </template>
      <template v-slot:cell(budget_number_cc)="items">
         <div
          v-for="(n, i) in items.item.volume_item.length + 1"
          :key="i"
          class="p-3"
          :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
        >
          {{
            n !== items.item.volume_item.length + 1
              ? items.item.volume_item[i].budget_number_cc ? items.item.volume_item[i].budget_number_cc : '-'
              : ''
          }}
        </div>
      </template>
      <template v-slot:cell(budget_number_plan)="items">
         <div
          v-for="(n, i) in items.item.volume_item.length + 1"
          :key="i"
          class="p-3"
          :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
        >
          {{
            n !== items.item.volume_item.length + 1
              ? items.item.volume_item[i].budget_number_plan ? items.item.volume_item[i].budget_number_plan : '-'
              : ''
          }}
        </div>
      </template>
      <template v-slot:cell(budget_number_ac)="items">
         <div
          v-for="(n, i) in items.item.volume_item.length + 1"
          :key="i"
          class="p-3"
          :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
        >
          {{
            n !== items.item.volume_item.length + 1
              ? items.item.volume_item[i].budget_number_ac ? items.item.volume_item[i].budget_number_ac : '-'
              : ''
          }}
        </div>
      </template>
      <template v-slot:cell(budget_number_sub_ac)="items">
         <div
          v-for="(n, i) in items.item.volume_item.length + 1"
          :key="i"
          class="p-3"
          :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
        >
          {{
            n !== items.item.volume_item.length + 1
              ? items.item.volume_item[i].budget_number_sub_ac ? items.item.volume_item[i].budget_number_sub_ac : '-'
              : ''
          }}
        </div>
      </template>
      <template v-slot:cell(budget_number_pa)="items">
         <div
          v-for="(n, i) in items.item.volume_item.length + 1"
          :key="i"
          class="p-3"
          :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
        >
          {{
            n !== items.item.volume_item.length + 1
              ? items.item.volume_item[i].budget_number_pa ? items.item.volume_item[i].budget_number_pa : '-'
              : ''
          }}
        </div>
      </template>
    </b-table>
    <b-table
      v-if="isEdit"
      class="mt-2 p-0"
      thead-class="bg-color text-center"
      empty-text="No data"
      :items="detail"
      :fields="fields"
      ref="editTable"
      responsive
      show-empty
      bordered
    >
      <template #thead-top>
        <b-tr>
          <b-th rowspan="2">Pit</b-th>
          <b-th rowspan="2">Seam</b-th>
          <b-th rowspan="2">Actual Distance</b-th>
          <b-th rowspan="2">Volume Coal Auxiliary</b-th>
          <b-th rowspan="2">Unit Price (IDR/Ton)</b-th>
          <b-th rowspan="2">Total Price (IDR/Ton)</b-th>
          <b-th colspan="5" class="text-center">Budget Number</b-th>
        </b-tr>
      </template>
      <template v-slot:cell(pit)="{ item }">
        <p class="font-weight-bold text-mid">{{ item.pit }}</p>
      </template>
      <template v-slot:cell(seam)="{ item }">
        <div
          v-for="(n, i) in item.volume_item.length + 1"
          :key="i"
          class="p-2 cell d-flex align-items-center"
          :class="i === item.volume_item.length ? '' : 'border-bottom'"
          :style="i === item.volume_item.length ? 'background-color: #9ed7d2;font-weight: bold' : ''"
        >
          <span v-if="i === item.volume_item.length">
          </span>
          <validation-provider
            v-else
            name="Seam"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill"
            >
            <b-form-input
              :value="item.volume_item[i].seam"
              size="sm"
              disabled
              :class="{ 'is-invalid': errors.length }"
            />
          </validation-provider>
        </div>
      </template>
      <template v-slot:cell(actual_distance)="{ item }">
        <div
          v-for="(n, i) in item.volume_item.length + 1"
          :key="i"
          class="p-2 cell d-flex align-items-center"
          :class="i === item.volume_item.length ? '' : 'border-bottom'"
          :style="i === item.volume_item.length ? 'background-color: #9ed7d2;font-weight: bold' : ''"
        >
          <span v-if="i === item.volume_item.length">
          </span>
          <validation-provider
            v-else
            name="Actual Distance"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill"
            >
            <b-form-input
              :value="formatMoney(parseFloat(item.volume_item[i].actual_distance), { symbol: '', precision: '2', thousand: ',' })"
              size="sm"
              disabled
              :class="{ 'is-invalid': errors.length }"
            />
          </validation-provider>
        </div>
      </template>
      <template v-slot:cell(volume)="{ item }">
        <div
          v-for="(n, i) in item.volume_item.length + 1"
          :key="i"
          class="p-2 cell d-flex align-items-center"
          :class="i === item.volume_item.length ? '' : 'border-bottom'"
          :style="i === item.volume_item.length ? 'background-color: #9ed7d2;font-weight: bold' : ''"
        >
          <span v-if="i === item.volume_item.length">
            {{
              formatMoney(
                  parseFloat(subTotal(item.volume_item, 'volume')),
                { symbol: '', precision: '2', thousand: ',' }
              )
            }}
          </span>
          <validation-provider
            v-else
            name="Volume Coal Auxiliary"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill"
            >
            <b-form-input
              :value="formatMoney(parseFloat(item.volume_item[i].volume), { symbol: '', precision: '2', thousand: ',' })"
              size="sm"
              disabled
              :class="{ 'is-invalid': errors.length }"
            />
          </validation-provider>
        </div>
      </template>
      <template v-slot:cell(unit_price)="{ item }">
        <div
          v-for="(n, i) in item.volume_item.length + 1"
          :key="i"
          class="p-2 cell d-flex align-items-center"
          :class="i === item.volume_item.length ? '' : 'border-bottom'"
          :style="i === item.volume_item.length ? 'background-color: #9ed7d2;font-weight: bold' : ''"
        >
          <span v-if="i === item.volume_item.length"></span>
          <validation-provider
            v-else
            name="Unit Price"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill"
            >
            <b-form-input
              autocapitalize="off"
              :value="formatMoney(parseFloat(item.volume_item[i].unit_price), { symbol: '', precision: '2', thousand: ',' })"
              size="sm"
              autocomplete="off"
              disabled
              :class="{ 'is-invalid': errors.length }"
            />
          </validation-provider>
        </div>
      </template>
      <template v-slot:cell(total_price)="{ item }">
        <div
          v-for="(n, i) in item.volume_item.length + 1"
          :key="i"
          class="p-2 cell d-flex align-items-center"
          :class="i === item.volume_item.length ? '' : 'border-bottom'"
          :style="i === item.volume_item.length ? 'background-color: #9ed7d2;font-weight: bold' : ''"
        >
          <span v-if="i === item.volume_item.length">
            {{
              formatMoney(
                  parseFloat(subTotal(item.volume_item, 'total_price')),
                { symbol: '', precision: '2', thousand: ',' }
              )
            }}
          </span>
          <b-form-input
            v-else
            autocapitalize="off"
            :value="formatMoney(parseFloat(item.volume_item[i].total_price), { symbol: '', precision: '2', thousand: ',' })"
            size="sm"
            autocomplete="off"
            disabled
          />
        </div>
      </template>
      <template v-slot:cell(budget_number_cc)="{ item, index }">
        <div
          v-for="(n, i) in item.volume_item.length + 1"
          :key="i"
          class="p-2 m-0 cell"
          :class="i === item.volume_item.length ? '' : 'border-bottom'"
        >
          <span v-if="i === item.volume_item.length"></span>
          <validation-provider
            v-else
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill"
          >
            <v-select
              v-model="item.volume_item[i].budget_number_cc"
              :clearable="false"
              :options="item.volume_item[i].budget_number_cc_list"
              :class="{ 'is-invalid': errors.length }"
              placeholder="cc"
              @option:selected="fetchBudgetNumber('cc', index, i, [item.volume_item[i].budget_number_cc])"
            />
          </validation-provider>
        </div>
      </template>
      <template v-slot:cell(budget_number_plan)="{ item, index }">
        <div
          v-for="(n, i) in item.volume_item.length + 1"
          :key="i"
          class="p-2 m-0 cell"
          :class="i === item.volume_item.length ? '' : 'border-bottom'"
        >
          <span v-if="i === item.volume_item.length"></span>
          <validation-provider
            v-else
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill"
          >
            <v-select
              v-model="item.volume_item[i].budget_number_plan"
              :clearable="false"
              :options="item.volume_item[i].budget_number_plan_list"
              :class="{ 'is-invalid': errors.length }"
              placeholder="plan"
              @option:selected="fetchBudgetNumber('plan', index, i, [item.volume_item[i].budget_number_cc, item.volume_item[i].budget_number_plan])"
            />
          </validation-provider>
        </div>
      </template>
      <template v-slot:cell(budget_number_ac)="{ item, index }">
        <div
          v-for="(n, i) in item.volume_item.length + 1"
          :key="i"
          class="p-2 m-0 cell"
          :class="i === item.volume_item.length ? '' : 'border-bottom'"
        >
          <span v-if="i === item.volume_item.length"></span>
          <validation-provider
            v-else
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill"
          >
            <v-select
              v-model="item.volume_item[i].budget_number_ac"
              :clearable="false"
              :options="item.volume_item[i].budget_number_ac_list"
              :class="{ 'is-invalid': errors.length }"
              placeholder="ac"
              @option:selected="fetchBudgetNumber('ac', index, i, [item.volume_item[i].budget_number_cc, item.volume_item[i].budget_number_plan, item.volume_item[i].budget_number_ac])"
            />
          </validation-provider>
        </div>
      </template>
      <template v-slot:cell(budget_number_sub_ac)="{ item, index }">
        <div
          v-for="(n, i) in item.volume_item.length + 1"
          :key="i"
          class="p-2 m-0 cell"
          :class="i === item.volume_item.length ? '' : 'border-bottom'"
        >
          <span v-if="i === item.volume_item.length"></span>
          <validation-provider
            v-else
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill"
          >
            <v-select
              v-model="item.volume_item[i].budget_number_sub_ac"
              :clearable="false"
              :options="item.volume_item[i].budget_number_sub_ac_list"
              :class="{ 'is-invalid': errors.length }"
              placeholder="sub ac"
              @option:selected="fetchBudgetNumber('sub_ac', index, i, [item.volume_item[i].budget_number_cc, item.volume_item[i].budget_number_plan, item.volume_item[i].budget_number_ac, item.volume_item[i].budget_number_sub_ac])"
            />
          </validation-provider>
        </div>
      </template>
      <template v-slot:cell(budget_number_pa)="{ item }">
        <div
          v-for="(n, i) in item.volume_item.length + 1"
          :key="i"
          class="p-2 m-0 cell"
          :class="i === item.volume_item.length ? '' : 'border-bottom'"
        >
          <span v-if="i === item.volume_item.length"></span>
          <validation-provider
            v-else
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill"
          >
            <v-select
              v-model="item.volume_item[i].budget_number_pa"
              :clearable="false"
              :options="item.volume_item[i].budget_number_pa_list"
              :class="{ 'is-invalid': errors.length }"
              placeholder="pa"
            />
          </validation-provider>
        </div>
      </template>
    </b-table>
    <br>
    <b-table
      class="mt-2"
      responsive
    >
      <template v-slot:custom-foot>
        <tr class="bg-color total border-top">
          <td class="font-weight-bold border-right">Grand Total</td>
          <td class="font-weight-bold text-right">{{ formatMoney(parseFloat(generateGrandTotal()), { symbol: '', precision: '2', thousand: ',' }) }}</td>
        </tr>
      </template>
    </b-table>
    <br>
    <h6 class="font-weight-bold">Attachment Supporting Document</h6>
    <div
      v-if="attachment.length && !isEdit"
      :style="gridStyle"
      class="card-list mt-4 p-0"
      id="attachment"
    >
      <div
        v-for="(item, index) in attachment"
        :key="index"
        class="supporting-file"
      >
        <div
          class="dropbox-files mx-1 mb-2"
          style="cursor: pointer;"
          @click="downloadFile(item.url)"
        >
          <div
            class="background-file"
          >
            <img
              v-if="checkType(item.file_name) === attachmentType[0] || checkType(item.file_name) === attachmentType[1]"
              class="my-4"
              src="@/assets/icon-excel.png"
              width="70"
              height="70"
            >
            <img
              v-else-if="checkType(item.file_name) === attachmentType[4]"
              class="my-4"
              src="@/assets/icon-pdf.png"
              width="70"
              height="70"
            >
            <img
              v-else-if="checkType(item.file_name) === attachmentType[2] || checkType(item.file_name) === attachmentType[3]"
              class="my-4"
              src="@/assets/icon-word.png"
              width="70"
              height="70"
            >
          </div>
          <div
            class="d-flex justify-content-between text"
          >
            <p class="text-ellipsis">{{ item ? item.file_name : 'NaN'}}</p>
            <p class="size-file">{{ item ? item.size : 'NaN mb'}}</p>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="isEdit"
      class="mt-4"
    >
      <div class="dropbox">
        <input
          type="file"
          @change="onChangeFile($event.target.files)"
          class="input-file"
          multiple
          accept=".xls, .xlsx, .doc, .docx, .pdf"
        >
          <img
            class="mt-2"
            src="@/assets/icon-upload.png"
            width="100"
            height="100"
          >
          <div>
            <p id="text-dropbox">Drag or klik button to upload file</p>
          </div>
          <b-button
            class="btn-custom"
            variant="info"
            size="sm"
          >
            Browse File
          </b-button>
      </div>
        <div
          v-if="attachment.length"
          :style="gridStyle"
          class="card-list mt-4 p-0"
          id="attachment"
          ref="attachment"
        >
          <div
            v-for="(item, index) in attachment"
            :key="index"
            class="supporting-file"
          >
            <div
              class="dropbox-files mx-1 mb-2"
            >
              <div
                class="background-file"
              >
                <div class="d-flex justify-content-end">
                  <img
                    class="mr-2 mt-2"
                    src="@/assets/icon-trash.png"
                    width="25"
                    height="25"
                    style="cursor: pointer"
                    @click="removeFile(index, item.id)"
                  >
                </div>
                <img
                  v-if="checkType(item.file_name) === attachmentType[0] || checkType(item.file_name) === attachmentType[1]"
                  class="mb-4"
                  src="@/assets/icon-excel.png"
                  width="70"
                  height="70"
                >
                <img
                  v-else-if="checkType(item.file_name) === attachmentType[4]"
                  class="mb-4"
                  src="@/assets/icon-pdf.png"
                  width="70"
                  height="70"
                >
                <img
                  v-else-if="checkType(item.file_name) === attachmentType[2] || checkType(item.file_name) === attachmentType[3]"
                  class="mb-4"
                  src="@/assets/icon-word.png"
                  width="70"
                  height="70"
                >
              </div>
              <div
                class="d-flex justify-content-between text"
              >
                <p class="text-ellipsis">{{ item ? item.file_name : 'NaN'}}</p>
                <p class="size-file">{{ item ? item.size : 'NaN mb'}}</p>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div v-else class="w-100 text-center">No Attachment</div>
  </div>
</template>

<script>
import api from '@/api'
import { formatMoney } from 'accounting-js'

export default {
  props: {
    detail: {
      type: Array,
      default: () => ([])
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    attachment: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    fields: [
      { key: 'pit', label: '', tdClass: 'text-center align-middle px-3', thClass: 'hidden-header' },
      { key: 'seam', label: '', tdClass: 'text-right p-0', thClass: 'hidden-header' },
      { key: 'actual_distance', label: '', tdClass: 'text-right p-0', thClass: 'hidden-header' },
      { key: 'volume', label: 'Volume Coal Auxiliary', tdClass: 'text-right p-0', thClass: 'hidden-header' },
      { key: 'unit_price', label: 'Unit Price (IDR/Ton)', tdClass: 'text-right p-0', thClass: 'hidden-header' },
      { key: 'total_price', label: 'Total Price (IDR/Ton)', tdClass: 'text-right p-0', thClass: 'hidden-header' },
      { key: 'budget_number_cc', label: 'CC', tdClass: 'text-center p-0', thStyle: 'width: 100px' },
      { key: 'budget_number_plan', label: 'Plan', tdClass: 'text-center p-0', thStyle: 'width: 100px' },
      { key: 'budget_number_ac', label: 'A/C', tdClass: 'text-center p-0', thStyle: 'width: 100px' },
      { key: 'budget_number_sub_ac', label: 'Sub A/C', tdClass: 'text-center p-0', thStyle: 'width: 100px' },
      { key: 'budget_number_pa', label: 'P/A', tdClass: 'text-center p-0', thStyle: 'width: 100px' }
    ],
    numberOfColumns: 4,
    grand_total: 0,
    attachmentType: ['xlsx', 'xls', 'doc', 'docx', 'pdf'],
    budgetNumberOptions: {
      cc: [],
      plan: [],
      ac: [],
      sub_ac: [],
      pa: []
    }
  }),
  computed: {
    gridStyle() {
      return {
        gridTemplateColumns: `repeat(${this.numberOfColumns}, minmax(25%, 1fr))`
      }
    }
  },
  methods: {
    formatMoney,
    checkType(fileName) {
      const splitFileName = fileName.split('.')
      return splitFileName[splitFileName.length - 1]
    },
    generateGrandTotal() {
      let grandTotal = 0
      for (let i = 0; i < this.detail.length; i++) {
        for (let j = 0; j < this.detail[i].volume_item.length; j++) {
          grandTotal += parseFloat(this.detail[i].volume_item[j].total_price)
        }
      }
      return grandTotal
    },
    async removeFile(index, fileId) {
      try {
        this.attachment.splice(index, 1)
        await api.coalAuxiliary.deleteAttachment(fileId)
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} - ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    async onChangeFile(value) {
      let isTypeAllowed = true
      let isSizeAllowed = true
      if (value.length + this.attachment.length > 10) {
        this.$nextTick(() => {
          this.$bvToast.toast('maximum file to upload only 10 files', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
        return
      }
      const formData = new FormData()
      for (let i = 0; i < value.length; i++) {
        const nameFile = value[i].name.split('.')
        if ((this.attachmentType.includes(nameFile[nameFile.length - 1]))) {
          if (value[i].size < 3072000) {
            formData.append('coal_auxiliaries_file', value[i])
          } else {
            isSizeAllowed = false
            break
          }
        } else {
          isTypeAllowed = false
          break
        }
      }
      if (!isTypeAllowed) {
        this.$nextTick(() => {
          this.$bvToast.toast('Only PDF, Excel and Doc files are allowed.', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }

      if (!isSizeAllowed) {
        this.$nextTick(() => {
          this.$bvToast.toast('Max size file 3 mb.', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
      if (isTypeAllowed && isSizeAllowed) {
        await this.uploadAttachment(formData)
      }
    },
    async uploadAttachment(formData) {
      try {
        await api.coalAuxiliary.uploadAttachment(this.$route.params.id, formData)
        setTimeout(() => {
          this.$emit('refresh')
        }, 1500)
        this.$refs.attachment.refresh()
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} - ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    async fetchBudgetNumber(code, index, i, value) {
      if (code === 'cc') {
        const data = await api.backupPayment.plan({
          cc: value[0]
        })
        this.detail[index].volume_item[i].budget_number_plan = null
        this.detail[index].volume_item[i].budget_number_ac = null
        this.detail[index].volume_item[i].budget_number_sub_ac = null
        this.detail[index].volume_item[i].budget_number_pa = null
        this.detail[index].volume_item[i].budget_number_plan_list = []
        this.detail[index].volume_item[i].budget_number_ac_list = []
        this.detail[index].volume_item[i].budget_number_sub_ac_list = []
        this.detail[index].volume_item[i].budget_number_pa_list = []
        this.detail[index].volume_item[i].budget_number_plan_list = data
      } else if (code === 'plan') {
        this.detail[index].volume_item[i].budget_number_ac = null
        this.detail[index].volume_item[i].budget_number_sub_ac = null
        this.detail[index].volume_item[i].budget_number_pa = null
        this.detail[index].volume_item[i].budget_number_ac_list = []
        this.detail[index].volume_item[i].budget_number_sub_ac_list = []
        this.detail[index].volume_item[i].budget_number_pa_list = []
        this.detail[index].volume_item[i].budget_number_ac_list = await api.backupPayment.ac({
          cc: value[0],
          plan: value[1]
        })
      } else if (code === 'ac') {
        this.detail[index].volume_item[i].budget_number_sub_ac = null
        this.detail[index].volume_item[i].budget_number_pa = null
        this.detail[index].volume_item[i].budget_number_sub_ac_list = []
        this.detail[index].volume_item[i].budget_number_pa_list = []
        this.detail[index].volume_item[i].budget_number_sub_ac_list = await api.backupPayment.subAC({
          cc: value[0],
          plan: value[1],
          ac: value[2]
        })
      } else if (code === 'sub_ac') {
        this.detail[index].volume_item[i].budget_number_pa = null
        this.detail[index].volume_item[i].budget_number_pa_list = await api.backupPayment.pa({
          cc: value[0],
          plan: value[1],
          ac: value[2],
          sub_ac: value[3]
        })
      }
      this.$refs.editTable.refresh()
    },
    downloadFile(url) {
      window.open(url)
    },
    subTotal(value, key) {
      let x = 0
      value.map(v => {
        x += v[key]
      })
      return x
    }
  }
}
</script>

<style lang="scss">
.form-control {
  font-size: 12px;
}

.col-form-label, .col-form-label-sm {
  font-size: 12px !important;
}

.total {
  font-size: 16px;
}

.text {
  height: fit-content;
  margin-top: 3px;
}

.text p {
  font-size: 14px;
}

.cell {
  height: 51px;
}

.background-file {
  background-color: #DBF9F6;
  border-radius: 16px;
}

.size-file {
  color: #D0C9D6;
}

#text-dropbox {
  font-size: 16px;
  text-align: center;
}

.dropbox {
  border: 2px dashed #463191;
  padding: 10px 10px;
  min-height: 150px;
  position: relative;
  border-radius: 16px;
  text-align: center;
  cursor: pointer;
}

.dropbox-files {
  border: 2px dashed #463191;
  padding: 10px 10px;
  min-height: 130px;
  position: relative;
  border-radius: 16px;
  text-align: center;
}

.input-file {
  margin-top: -12px;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 220px;
  position: absolute;
  cursor: pointer;
}
.dropbox p {
  font-size: 12px;
  text-align: center;
  padding-top: 20px;
}

.card-list {
  display: grid;
  grid-gap: 2px;
}

.text-ellipsis {
  max-width: 200px;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-mid {
  padding-top: 13px;
}

.pay-background {
  background-color: #e9fbf9;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width:100%
}

.pending-background {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #EAE7F3;
  height: 100%;
  width:100%
}

.hidden-header {
  display: none;
}

@media print{
  @page {
    size: landscape;
    margin-top: -90px;
  }
}

@media only screen and (max-width: 768px) {
  .dropbox {
    width: 100%;
    position: relative;
  }
}
</style>
